import { graphql } from 'react-apollo'
import getImageFromEntry, {
  MASTER,
  STANDARD,
} from '../../helpers/get-image-from-entry'
import { ApplicationError, NotFoundError } from '../../helpers/errors'
import { localISODate, getWeekAhead } from '../../helpers/date-helpers'
import getLogoFromRetailer from '../../helpers/get-logo-from-retailer'
import getMoviesWithSessions from '../../helpers/get-movies-with-sessions'

import { MOVIE_DAYS_IN_ADVANCE } from '../../constants'
import query from './query.graphql'

export { query }

export const mapPropsToOptions = ({ centre }) => ({
  variables: {
    centreId: centre.slug,
    id: centre.sys.id,
    startsAt: localISODate(centre.timeZone),
  },
})

export const mapDataToProps = ({
  data: { movies, centre: respCentre, loading, error },
  ownProps: { centre },
}) => {
  if (error) {
    return {
      error: new ApplicationError(error),
    }
  } else if (loading) {
    return { loading }
  } else if (!respCentre || !respCentre.cinema) {
    return {
      error: new NotFoundError(),
    }
  }

  const { cinema } = respCentre
  return {
    movies: getMoviesWithSessions(movies, centre.timeZone),
    logo: getLogoFromRetailer(respCentre.cinema.retailer),
    cinema: {
      ...cinema,
      openHours: {
        storeTradingSchedule: cinema.storeTradingSchedule,
        centreTradingSchedule: centre.centreTradingSchedule,
        timeZone: centre.timeZone,
      },
    },
    desktopBackgroundImage: getImageFromEntry(cinema, MASTER),
    mobileBackgroundImage: getImageFromEntry(cinema, STANDARD),
    nextWeek: getWeekAhead(centre.timeZone, MOVIE_DAYS_IN_ADVANCE),
  }
}

const withCinema = graphql(query, {
  options: mapPropsToOptions,
  props: mapDataToProps,
})

export default withCinema
